import { updateQueueById } from './queue';
import { mockOrganizations } from '../Components/Pages/Host/OrgnizationsList/mockData';
const { db, auth } = require('../FirebaseConfig');
const {
  ref,
  get,
  set,
  push,
  update,
  query,
  remove,
  orderByChild,
  equalTo,
} = require('firebase/database');

const organizationsDbRef = ref(db, 'organizations');

//fallback for missing data
const fallbackData = {
  name: 'not provided',
  brandColor: '#fff',
  logo: 'not set',
  description: 'description was not added',
  logoImg: "",
};

// Function to create a new organization
export const createNewOrganization = async (organization) => {
  const currentUser = auth.currentUser; // Get authenticated user
  if (!currentUser) {
    console.error('No authenticated user found.');
    return;
  }
  const newOrganizationKey = push(organizationsDbRef).key;
  const newOrganization = {
    orgName: organization.name || fallbackData.name,
    brandColor: organization.brandColor || fallbackData.brandColor,
    description: organization.description || fallbackData.description,
    ownerId: currentUser.uid, // Assign correct authenticated user ID
    id: newOrganizationKey,
  };
  // Only add logoImg if it's not null or undefined
  if (organization.logoImg !== null && organization.logoImg !== undefined) {
    newOrganization.logoImg = organization.logoImg;
  }

  try {
    await set(ref(db, `organizations/${newOrganizationKey}`), newOrganization);
  } catch (e) {
    console.error(e);
  }
};

// Function to fetch organizations belonging to a specific user
export const getUsersOrganizations = async (ownerId) => {
    if (localStorage.getItem('useMock') === 'true') {
      setTimeout(() => Promise.resolve(mockOrganizations), 1000);
    }
  const organizationsQuery = query(
    organizationsDbRef,
    orderByChild('ownerId'),
    equalTo(ownerId)
  );
  try {
    const organizationsSnapshot = await get(organizationsQuery);
    if (organizationsSnapshot.exists()) {
      const organizations = await organizationsSnapshot.val();
      return [...Object.values(organizations)];
    } else {
      return [];
    }
  } catch (e) {
    console.error(e);
    return [];
  }
};

// Function to update an organization
export const updateUsersOrganization = async (
  organizationId,
  organizationUpdatedDetails
) => {
  try {
    await update(ref(db, `organizations/${organizationId}`), {
      ...organizationUpdatedDetails,
    });
  } catch (e) {
    console.error(e);
  }
};

// Function to delete an organization
export const deleteOrganization = async ( orgId) => {
  const filteredQueuesQuery = query(
    ref(db, 'queues'),
    orderByChild('organizationId'),
    equalTo(orgId)
  );
  try {
    const queuesSnapshot = await get(filteredQueuesQuery);
    if (queuesSnapshot.exists()) {
      for (const queueId in queuesSnapshot.val()) {
        await updateQueueById(queueId, { organizationId: '' });
      }
    }
  } catch (e) {
    console.error('Error:', e);
  }

  try {
    await remove(ref(db, `organizations/${orgId}`));
  } catch (e) {
    console.error(e);
  }
};

export const getOrganizationInfoById = async (orgId) => {
  const organizationsQuery = query(
    organizationsDbRef,
    orderByChild('id'),
    equalTo(orgId)
  );
  try {
    const organizationSnapshot = await get(organizationsQuery);
    if (organizationSnapshot.exists()) {
      return Object.values(organizationSnapshot.val())[0];
    } else {
      return null;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
}
